import gql from "graphql-tag";

const CAMPAIGN_WITH_PHONE_NUMBER_DETAILS = gql`
  fragment CampaignWithPhoneNumberDetails on Campaign {
    id
    minimum_outgoing_number_pool_size
    outboundPhoneNumbers {
      id
      phoneNumber
      rotateJob {
        id
        createTime
        status
      }
      rotationErrorAt
      callsMade
      autoRotatable
      stirShakenApproved
      voiceIntegrityApproved
    }
  }
`;

export const GET_CAMPAIGN_PHONE_NUMBER_DETAILS = gql`
  ${CAMPAIGN_WITH_PHONE_NUMBER_DETAILS}
  query campaignPhoneNumberDetails($campaignId: ID!) {
    campaign(id: $campaignId) {
      ...CampaignWithPhoneNumberDetails
    }
  }
`;

export const FORCE_ROTATE_CAMPAIGN_PHONE_NUMBER = gql`
  ${CAMPAIGN_WITH_PHONE_NUMBER_DETAILS}
  mutation forceRotateCampaignPhoneNumber($campaignId: ID!, $numberId: ID!) {
    campaignForceRotatePhoneNumber(id: $campaignId, numberId: $numberId) {
      ...CampaignWithPhoneNumberDetails
    }
  }
`;

export const EDIT_ROTATABLE_CAMPAIGN_PHONE_NUMBER = gql`
  ${CAMPAIGN_WITH_PHONE_NUMBER_DETAILS}
  mutation campaignEditAutoRotatablePhoneNumber(
    $campaignId: ID!
    $numberId: ID!
    $autoRotate: Boolean!
  ) {
    campaignEditAutoRotatablePhoneNumber(
      id: $campaignId
      numberId: $numberId
      autoRotate: $autoRotate
    ) {
      ...CampaignWithPhoneNumberDetails
    }
  }
`;

export const EDIT_OUTBOUND_POOL_SIZE = gql`
  ${CAMPAIGN_WITH_PHONE_NUMBER_DETAILS}
  mutation campaignEditOutboundPoolSize($campaignId: ID!, $newPoolSize: Int!) {
    campaignEditOutboundPoolSize(id: $campaignId, newPoolSize: $newPoolSize) {
      ...CampaignWithPhoneNumberDetails
    }
  }
`;
